import { Component as ReactComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment-timezone';

import './styles.scss';

export class DateTimeItem extends ReactComponent {

    render() {
        const self = this;
        const {timeZoneId, utcDate, format, className} = self.props;

        if (!Boolean(utcDate)) {
            return null;
        }
        
        const date = moment.utc(utcDate);

        const utcDateStr = date.format(format);
        const tzDate = Boolean(timeZoneId) ? date.tz(timeZoneId) : date;

        const tzDateStr = Boolean(timeZoneId)
            ? tzDate.format(format)
            : utcDateStr;

        return (
            <span 
                title={(tzDateStr != utcDateStr) ? utcDateStr : ''}
                className={className}
            >
                {tzDateStr}
            </span>
        )
    }
}
DateTimeItem.propTypes = {
    utcDate: PropTypes.any,
    timeZoneId: PropTypes.string,
    format: PropTypes.string.isRequired,
    className: PropTypes.string,
}
DateTimeItem.defaultProps = {
    timeZoneId: 'America/New_York',
    format: 'L LT (z)',
}